import { Modal } from 'bootstrap';


export default function initModals(){
	const createModalTemplate = (id, title, css_class) =>{
		const modalHtml = `
			<div id="${id}" class="modal fade ${css_class}" tabindex="-1" aria-labelledby="${id}-label" aria-hidden="true" role="dialog" aria-modal="true" style="display: none">
				<div class="modal-dialog">
					<div class="modal-content">
					<div class="modal-header">
						<h5 class="visually-hidden" id="form-modal-${id}-label">${title}</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="loading-spinner"></div>
					</div>
					</div>
				</div>
			</div>
		`;
		const existingModal = document.getElementById(`${id}`);
		if(existingModal){
			existingModal.remove();
		}
		//remove formstack objects if they exist so the modal can be opened more than once
		delete window.executeDefaultFormLoad;
		delete window.LoadSwiftForm;
		delete window.fsFormEngine;
		Object.keys(window).forEach(key => {
			if (key.startsWith('ff')) {
				try{
					delete window[key];
				}catch(e){
					console.log(e);
				}
			}
		});

		const existingFastForms = document.getElementById('jsFastForms');
		if(existingFastForms){
			existingFastForms.remove();
		}
		const fastForm = document.getElementById('dvFastForms');
		if (fastForm) {
			fastForm.remove();
		}

		document.querySelector('html').insertAdjacentHTML('beforeend', modalHtml);
	}

	// any links on the page to /request-appointment should open a modal window instead of navigating
	const links = document.querySelectorAll('a[href*="appointment-request"]');
	links.forEach( link => {

		if (link.closest('.contact-item')) { link = link.closest('.contact-item'); }

		link.addEventListener('click', async(e) => {
			createModalTemplate(`appointment-modal`, 'Book an Appointment', 'form-modal-template');
			const modalEl = document.getElementById('appointment-modal');
			if(modalEl){
				e.preventDefault();

				const modal = new Modal(document.getElementById('appointment-modal'));
				modal.show();

				const options = {
					method: 'POST',
					credentials: 'same-origin',
					headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
					body: 'action=getpost'
				}

				const response = await window.fetch(mefa.adminAjax+"?action=getpost&postId=3206", options)
					.then(response => response.text())
					.catch(error => console.error(error));

				if (response) {
					// const modal = new Modal(document.getElementById('appointment-modal'));
					const modalBody = modalEl.querySelector('.modal-body');
					modalBody.innerHTML = response;
					const scripts = modalBody.querySelectorAll('script');
					scripts.forEach(script => {
						const newScript = document.createElement('script');
						if (script.src) {
							newScript.src = script.src;
						} else {
							newScript.textContent = script.textContent;
						}
						document.head.appendChild(newScript);
						document.head.removeChild(newScript);
					});

					// modal.show();
				}

			}
		});
	});

	const languageChooser = document.querySelectorAll('.language-chooser-launcher');
	languageChooser.forEach( link => {
		link.addEventListener('click', async(e) => {
			const modalEl = document.getElementById('language-modal');
			if(modalEl){
				e.preventDefault();
				window.languageModal = new Modal(document.getElementById('language-modal'));
				window.languageModal.show();

			}
		});
	});

	const formModalLinks = document.querySelectorAll('a[href*="#form-"]');
	formModalLinks.forEach( link => {
		if(link.href.includes('#form-')){
			const formId = link.href.split('#form-')[1];
			const form = window.MEFA_Forms?.find(form => form?.trigger === 'form-'+formId);

			if(form){
				link.addEventListener('click', async(e) => {
					e.preventDefault();
					createModalTemplate(`form-modal-${form.id}`, 'form', 'form-modal-template');
					const modalEl = document.getElementById(`form-modal-${form.id}`);
					if(modalEl){
						const modal = new Modal(document.getElementById(`form-modal-${form.id}`));
						modal.show();

						const options = {
							method: 'POST',
							credentials: 'same-origin',
							headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
							body: 'action=getblock'
						}

						const response = await window.fetch(`${mefa.adminAjax}?action=getblock&id=${form.trigger}&post_id=${form.post}`, options)
							.then(response => response.text())
							.catch(error => console.error(error));

						if (response) {
							const modalBody = modalEl.querySelector('.modal-body');
							modalBody.innerHTML = response;
							const scripts = modalBody.querySelectorAll('script');
							scripts.forEach(script => {
								const newScript = document.createElement('script');
								if (script.src) {
									newScript.src = script.src;
								} else {
									newScript.textContent = script.textContent;
								}
								document.head.appendChild(newScript);
								document.head.removeChild(newScript);
							});
						}
					}
				});
			}
		}
	});
}

